import React from "react";
import { Seo } from "../lib/seo";
import { Section, SectionHead, Button } from "../components/ui";
import { DataTable } from "../components/marketing";
import { DOCS_URL } from "../data/nav";

export default function Developers() {
  return (
    <>
      <Seo title="API & Webhooks" path="/developers/" description="The BloomCONNECT REST API: 40+ resources, three authentication methods, webhooks with HMAC signing, and an MCP server." />
      <Section>
        <SectionHead label="Developers" title="Build on the BloomCONNECT API." intro="A REST API with 40+ resources, three authentication methods, webhooks, and an MCP server." />
        <dl className="mt-8 grid gap-6 md:grid-cols-3">
          {[["Base URL","https://api.connect.bybloomlabs.com"],["Auth","API key, OAuth, or session token"],["Format","JSON, cursor pagination, RFC-7807 errors"]].map(([k,val])=>(
            <div key={k} className="card-hairline p-5"><dt className="eyebrow mb-1">{k}</dt><dd className="font-mono text-sm text-ink-800 break-all">{val}</dd></div>
          ))}
        </dl>
      </Section>
      <Section sunk>
        <SectionHead n="01" label="Resources" title="Endpoints by resource group." />
        <div className="mt-8"><DataTable caption="Endpoint groups" head={["Group","Example endpoint"]} rows={[["Contacts","GET /contacts"],["Messages","POST /messages"],["Campaigns","POST /campaigns"],["FAQs","GET /faqs"],["Appointments","POST /appointments"],["Tasks","GET /tasks"],["Channels","GET /channels"],["Phone numbers","GET /phone-numbers"],["Webhooks","POST /webhooks"],["Analytics","GET /analytics"],["Chat widget","GET /widget"],["WhatsApp templates","GET /wa-templates"]]} /></div>
      </Section>
      <Section>
        <SectionHead n="02" label="Example" title="Send a message." />
        <pre className="mt-6 rounded-lg border border-line bg-surface-ink text-white p-5 overflow-x-auto text-sm"><code>{`curl -X POST https://api.connect.bybloomlabs.com/messages \\
  -H "Authorization: Bearer $API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{"contact_id":"c_123","channel":"whatsapp","text":"Hi!"}'`}</code></pre>
      </Section>
      <Section sunk>
        <SectionHead n="03" label="Webhooks" title="~20 events, HMAC-signed." />
        <div className="mt-8"><DataTable caption="Webhook events" head={["Event","Fires when"]} rows={[["message.received","A contact sends a message"],["message.sent","The agent replies"],["contact.created","A new contact is added"],["appointment.booked","A slot is booked in-chat"],["campaign.completed","A campaign finishes"],["handover.requested","The agent hands to a human"]]} /></div>
        <pre className="mt-6 rounded-lg border border-line bg-surface-ink text-white p-5 overflow-x-auto text-sm"><code>{`const sig = req.headers['x-signature'];
const expected = hmac('sha256', SECRET, req.rawBody);
if (sig !== expected) return res.status(401).end();`}</code></pre>
        <div className="mt-8"><Button href={DOCS_URL} variant="secondary" size="md">Full API reference</Button></div>
      </Section>
    </>
  );
}
